"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import type { WorkspaceApplication } from "@/app/components/workspace/apps/registry";

export function WorkspaceApplicationUnavailable({
  application,
  workspaceUuid,
}: {
  application: WorkspaceApplication;
  workspaceUuid: string;
}) {
  const messages = useTranslations();
  const t = useTranslations("apps.workflows.app-lifecycle");
  const applicationTitle = messages(`${application.translationKey}.title`);

  return (
    <div className="mx-auto flex min-h-[55vh] max-w-2xl items-center justify-center">
      <div className="panel w-full px-6 py-10 text-center sm:px-10">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-warning-subtle text-warning">
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
            className="h-7 w-7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 3 2.8 20h18.4L12 3Z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v5M12 17h.01" />
          </svg>
        </div>
        <h1 className="mt-5 text-2xl font-bold tracking-tight text-text">
          {t("unavailable.title", { application: applicationTitle })}
        </h1>
        <p className="mx-auto mt-3 max-w-lg text-sm leading-6 text-text-secondary">
          {t("unavailable.description")}
        </p>
        <Link
          href={`/c/${workspaceUuid}`}
          prefetch={false}
          className="btn-base btn-primary mt-6"
        >
          {t("unavailable.backToLauncher")}
        </Link>
      </div>
    </div>
  );
}
